/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState,useEffect,useRef  } from "react";
import { connect } from 'react-redux';
// nodejs library that concatenates classes
import classnames from "classnames";
// reactstrap components
import { Row, Col } from "reactstrap";
import { FormGroup, Input } from "reactstrap";
import {setLogo,setSelectedContactUser,setSelectedContactAddress,setSelectedContactInfo,setSelectedCompany, setValidDate, setQuoteLabel, setClientOrderNumber, setDeliveryRequired, setCompanies, setCompanyUpdated, setContactUpdated, setQuoteLoading} from '../../actions/quote'
import ReactDatetime from "react-datetime";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import axios from 'axios';
import SelectSearch from '../IndexSections/SelectSearch.js';
import { toast } from 'react-toastify';
import CompanyForm from "./CompanyForm"
import ContactForm from "./ContactForm"
import {Collapse} from 'react-collapse';
import { Tooltip } from 'reactstrap';
import Memo from "./Memo"
import { Editor } from '@tinymce/tinymce-react';



function Index(props) {
  const [openBody, setOpenBody] = useState(true);
  const [openContactEdit, setOpenContactEdit] = useState(false);
  const [openLabelEdit, setOpenLabelEdit] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [noteModal, setNoteModal] = useState(false);
  const [newMemoNote, setNewMemoNote] = useState("");
  const [memoNote, setMemoNote] = useState("");
  const [company, setCompany] = useState(null);
  const [addresses, setAddresses] = useState([]);
  const [quote, setQuote] = useState(null);
  const [userId, setUserId] = useState(null);
  const [companyList, setCompanyList] = useState([]);
  const [memos, setMemos] = useState([]);
  const logoRef = useRef(null);

  
  const toggleNote = () => setNoteModal(!noteModal);
  const toggletooltip = () => setTooltipOpen(!tooltipOpen);

  const user = localStorage.getItem('user_bigbrand');
  var userinfo;
  var role = ""
  if(user && user != undefined){
    userinfo = JSON.parse(user)
    role = userinfo['role']
  }

  const {
    selectedContactUser,
    selectedContactAddress,
    selectedContactInfo,
    selectedCompany,
    validDate,
    quoteLabel,
    delivery_required
  } = props.quote;
  
  const {
    contactNames
  } = props;

  const addMemo =async()=>{
    var userId = null
    if(role=="admin" && companyList.length>0){
      if(props.selectedCompany && props.selectedCompany.length > 0){ 
        var value = props.selectedCompany[0]['key'];
        var tmp = value.split(" - ")
        userId = tmp[0]; var company_id = tmp[1];
      }
    }
    else{
      userId = userinfo['id']
    }

    if(userId) {
      var bodyFormData = new FormData();
      bodyFormData.append('memo_note', newMemoNote);
      bodyFormData.append('user_to', userId);
      if(quote){
        axios.post(`/quotes/addcompanymemo`, bodyFormData).then(res => {
          const result = res.data;
          if(result.status == "success"){        
            getmemo();
            // setNoteModal(false)
          }
          else{
            toast.error(result.data);
          }
        }).catch(err => {
          toast.error('Something was wrong. Try again');
        })
      }
      else{
        toast.error('Quote is empty');
      }
    }
  }

  const uploadfile =async(e)=>{
    var userId = null
    if(role=="admin" && companyList.length>0){
      if(props.selectedCompany && props.selectedCompany.length > 0){ 
        var value = props.selectedCompany[0]['key'];
        var tmp = value.split(" - ")
        userId = tmp[0]; var company_id = tmp[1];
      }
    }
    else{
      userId = userinfo['id']
    }

    if(userId) {
      var bodyFormData = new FormData();
      bodyFormData.append('user_to', userId);
      bodyFormData.append('file', e.target.files[0]); 
      if(quote){
        axios.post(`/quotes/uploadmemofile`, bodyFormData).then(res => {
          console.log("UPLOAD FROM: EditQuote.js");
          const result = res.data;
          if(result.status == "success"){        
            getmemo();
            // setNoteModal(false)
          }
          else{
            toast.error(result.data);
          }
        }).catch(err => {
          toast.error('Something was wrong. Try again');
        })
      }
      else{
        toast.error('Quote is empty');
      }
    }
  }

  const updateCompany=(company)=>{
    var bodyFormData = new FormData();
    if(company.logo){
      delete company.logo
    }
    bodyFormData.append('company', JSON.stringify(company));
    if(!company){
      toast.error('Form is empty');
      return;
    }
    
    if(!company.company || company.company == ""){
      toast.error('Company Name is required');
      return;
    }

    // mykhailo - 20251022
    // check if minimal content inputted
    const company_number = company?.phone?.trim();
    if(!company_number){
      toast.error('Contact Number is required');
      return;
    }

    const company_email = company?.email?.trim();
    if(!company_email){
      toast.error('Email Address is required');
      return;
    }

    // const company_referral = company?.referral?.trim();
    // if(!company_referral){
    //   toast.error('Referral is required');
    //   return;
    // }

    if(company&& company.id){
      props.setCompanyUpdated(false)
      props.setQuoteLoading(true)
      axios.post(`/companies/edit/${company.id}`, bodyFormData).then(res => {
        const result = res.data;
        if(result.status == "success"){        
          toast.success("Your company has been updated"); 
          setCompany(res.data.data)
          props.setCompanyUpdated(true)
        }
        else{
          toast.error(result.data);
          fetchAll()
        }
        props.setQuoteLoading(false)
      }).catch(err => {
        toast.error('Something was wrong. Try again');
      })
    }
    else{
      props.setCompanyUpdated(false)
      props.setQuoteLoading(true)
      axios.post(`/companies/add/`, bodyFormData).then(res => {
        const result = res.data;
        if(result.status == "success"){        
          toast.success("New company has been added"); 
          var companies = res.data.data        
          initCompanyList(companies)
          props.setCompanyUpdated(true)
        }
        else{
          toast.error(result.data);
        }
        props.setQuoteLoading(false)
      }).catch(err => {
        toast.error('Something was wrong. Try again');
      })
    }
  } 


  const updateContact=(contact)=>{
    if(!company || (company && !company.id)){
      toast.error('Create the company first');
      return false;
    }
    var bodyFormData = new FormData();
    contact.company_id = company.id
    bodyFormData.append('contact', JSON.stringify(contact));

    // mykhailo - 20251022
    // check if minimal content inputted
    const contact_firstname = contact?.firstname?.trim();
    if(!contact_firstname){
      toast.error('First Name is required');
      return;
    }

    const contact_position = contact?.position?.trim();
    if(!contact_position){
      toast.error('Position is required');
      return;
    }

    const contact_mobile = contact?.mobile?.trim();
    if(!contact_mobile){
      toast.error('Mobile number is required');
      return;
    }

    const contact_email = contact?.email?.trim();
    if(!contact_email){
      toast.error('Contact Email is required');
      return;
    }
    
    if(contact.id){
      props.setContactUpdated(false)
      props.setQuoteLoading(true)
      axios.post(`/companies/editcontact/${contact.id}`, bodyFormData).then(res => {
        const result = res.data;
        if(result.status == "success"){        
          toast.success("Your contact has been updated"); 
          setCompany(res.data.data)
          props.setContactUpdated(true)
        }
        else{
          toast.error(result.data);
        }
        props.setQuoteLoading(false)
      }).catch(err => {
        toast.error('Something was wrong. Try again');
      })
    }
    else{
      props.setContactUpdated(false)
      props.setQuoteLoading(true)
      axios.post(`/companies/addcontact`, bodyFormData).then(res => {
        const result = res.data;
        if(result.status == "success"){        
          toast.success("Your contact has been added"); 
          setCompany(res.data.data)
          props.setContactUpdated(true)
        }
        else{
          toast.error(result.data);
        }
        props.setQuoteLoading(false)
      }).catch(err => {
        toast.error('Something was wrong. Try again');
      })
    }
  } 
  
  const onChangeLogo=(e)=>{
    if(e.target.files[0]){
      var bodyFormData = new FormData();
      bodyFormData.append('logo', e.target.files[0]);
      axios.post(`/companies/addlogo/${company.id}`, bodyFormData).then(res => {
        const result = res.data;
        if(result.status == "success"){        
          toast.success("Your logo has been uploaded");
          setCompany(res.data.data)
        }
        else{
          toast.error(result.data);
        }
      }).catch(err => {
        toast.error('Something was wrong. Try again');
      })
    }
    logoRef.current.value = null
  }
    
  const initCompanyList = (companies)=>{
    setCompanyList(companies)
    var tmp = [];
    for(var i = 0; i< companies.length; i++){
      if(companies[i]['user']){
        tmp.push({
          key:  companies[i]['user']['id']+" - "+companies[i]['id'],
          label: companies[i]['company']
        })
      }
    }
    props.setCompanies(tmp)
  }
  
  const getCompanies = ()=>{
    axios.get(`/companies/list/`).then(res => {
      console.log('res.data',res.data)
      if(res.data.status == "success"){
        var companies = res.data.data        
        initCompanyList(companies)
      }
    }) 
  }
  
  const getmemo=()=>{
    var userId = null
    if(role=="admin" && companyList.length>0){
      if(props.selectedCompany && props.selectedCompany.length > 0){ 
        var value = props.selectedCompany[0]['key'];
        var tmp = value.split(" - ")
        userId = tmp[0]; var company_id = tmp[1];
      }
    }
    else{
      userId = userinfo['id']
    }

    if(userId) {
      axios.get(`/quotes/getcompanymemo/${userId}`).then(res => {
        if(res.data.status == "success"){
          setMemos(res.data.data)
        }
      }) 
    }
  }

  
  const removememo = (id)=>{
    axios.get(`/quotes/removememo/${id}`).then(res => {
      if(res.data.status == "success"){
        getmemo()
      }
    }) 
  }

  useEffect(() => { 
    getCompanies()   
    getmemo()
  },[]);


  useEffect(() => {    
    if(props.quote.contact_updated || props.quote.company_updated){
      getCompanies();
    }
  },[props.quote.contact_updated, props.quote.company_updated]);
  
  useEffect(() => {  
    fetchAll()
    
  },[props.selectedCompany,companyList]);

  const fetchAll = ()=>{
    if(role=="admin" && companyList.length>0){
      if(props.selectedCompany && props.selectedCompany.length > 0){ 
        var value = props.selectedCompany[0]['key'];
        var tmp = value.split(" - ")
        var userId = tmp[0]; var company_id = tmp[1];
        axios.get(`/companies/getcompanybyuser/${userId}`).then(res => {
          console.log('res.data',res.data)
          if(res.data.status == "success"){
            var company = res.data.data
            if(company){
              setCompany(company)
            }
          }        
        })   
        
        props.setQuoteLoading(true);
        axios.get(`/quotes/getquotebyid/${userId}`).then(res => {
          console.log('res.data',res.data)
          if(res.data.status == "success"){
            var quote = res.data.data
            if(quote){
              setMemoNote(quote.memo_note)
              setQuote(quote)
            }
            else{
              setMemoNote('')
              setQuote(null)
            }
          }
          props.setQuoteLoading(false);
        }) 
      }
      else{
        setMemoNote('')
        setCompany(null);
        setQuote(null)
      }
    }
    else{
      axios.get(`/companies/getcompanybyuser/${userinfo['id']}`).then(res => {
        console.log('res.data',res.data)
        if(res.data.status == "success"){
          var company = res.data.data
          if(company){
            setCompany(company)
          }
        }        
      })   
      props.setQuoteLoading(true);
      axios.get(`/quotes/getquotebyid/${userinfo['id']}`).then(res => {
        console.log('res.data',res.data)
        if(res.data.status == "success"){
          var quote = res.data.data
          if(quote){
            setMemoNote(quote.memo_note)
            setQuote(quote)
          }
          else{
            setMemoNote('')
            setQuote(null)
          }
        }
        props.setQuoteLoading(false);
      }) 
    }
    
    getmemo()
  }

  // useEffect(() => { 
  //   if(props.quote){
  //     if(props.quote.memo_note)
  //       setMemoNote(props.quote.memo_note)
  //     setUserId(props.quote.user_id)
  //   }
  // },[props.quote]);
  
  // useEffect(() => { 
  //   if(userId){
  //     axios.get(`/companies/getcompanybyuser/${userId}`).then(res => {
  //       console.log('res.data',res.data)
  //       if(res.data.status == "success")
  //         var company = res.data.data
  //         if(company){
  //           setCompany(company)
  //         }
  //     }) 
      
  //     // axios.get(`/addresses/index/${userId}`).then(res => {
  //     //   console.log('res.data',res.data)
  //     //   if(res.data.status == "success")
  //     //     var addresses = res.data.data
  //     //     if(addresses){
  //     //       setAddresses(addresses)
  //     //     }
  //     // }) 
  //   }
  // },[userId]);
  
  const toggleOpenContactEdit = () => {
    setOpenContactEdit(!openContactEdit);
  }
  const toggleOpenLabelEdit = () => {
    setOpenLabelEdit(!openLabelEdit);
  }
  const onChangeContact=(value)=>{
    props.setSelectedContactUser(value)
    var found = false;
    for(var index in contactNames){
      var contact  = contactNames[index];
      if(contact['id'] == value){
        if(contact){
          var address = 
          (contact['fullname']?contact['fullname']:"")+"\n\n"+(contact['address']?contact['address']:"")+"\n"+(contact['suburb']?contact['suburb']:"")+", "+(contact['state']?contact['state']:"")+", "+(contact['postcode']?contact['postcode']:"");
          props.setSelectedContactAddress(address);
          var company = 
          (contact['company']?contact['company']:"")+"\n"+(contact['phone']?contact['phone']:"")+"\n"+(contact['email']?contact['email']:"");
          props.setSelectedContactInfo(company);
          found = true; break;
        }
      }
    }
    if(!found){
      props.setSelectedContactAddress("");
      props.setSelectedContactInfo("");
    }
  }


  const renderDate = (props, openCalendar, closeCalendar)=> {
    function clear() {
      props.onChange({ target: { value: "" } });
    }
    return (
      <div className="d-flex">        
        <label className="mb-0" style={{width:60}}><b>Valid To</b> </label>
        <div className="field" style={{width:'calc(100% - 60px)'}}>
          <span style={{fontSize:'0.875rem'}} className="pl-2 pr-2">{validDate}</span>
          { role=="admin"&&<i style={{float:'right', marginTop:5}} onClick={openCalendar} className="fa fa-calendar cursor-pointer ml-2 mr-2"/>}
        </div>
      </div>
    );
  }
  

  var today = new Date();
  var date = (today.getMonth()+1)+'/'+today.getDate()+'/'+today.getFullYear();

  
  
  const categories = props.quote.categories;
  var decoration = "";
  for(var index in categories){
    const category = categories[index]
    var groups = category.items
    if(groups){
      for(var groupInd = 0; groupInd< groups.length; groupInd++){
        var items = groups[groupInd]
        if(items){
          for(var loop = 0; loop < items.length; loop++){
            var item = items[loop];
            if(item.type == "decoration"){
              decoration = item['code']?item['code']:"";
            }
          }
        }
      }
    }
    break;
  } 
  console.log("company", company)
  return (
    <>
      <Row className="">     
        <Col className="text-left" xs="12">
          <Row className="order-header-head">       
            <Col className="text-left" xs="4">
              <h6><b>Quote</b></h6>
            </Col>    
            <Col className="text-left" xs="4">  
              <h6><b>Company</b></h6>
            </Col>   
            <Col className="text-left" xs="4">
                <h6><b>Contact</b></h6>    
            </Col>   
            <div className="expand-btn" onClick={()=>setOpenBody(!openBody)}>  
            {
              openBody?
              <span style={{fontSize:36}} className="material-icons ">expand_less</span> :
              <span style={{fontSize:36}} className="material-icons ">expand_more</span>
            }            
            </div>
          </Row>
        </Col>   
      </Row>
      <Collapse isOpened={openBody}>
        <Row className="order-header order-header-body">              
          <Col xs="12">
            <Row className="m-0">
              <Col xs="4" className="card-col"> 
                {role=="admin" &&
                <SelectSearch className="select-company" customFilter={true} options={props.quote.companies?props.quote.companies:[]} disabled={!props.quote.companies || props.quote.companies==0} placeholder="Search Company" onChange={values => {props.onChangeCompany(values)}} values={props.selectedCompany} searchBy="label" labelField="label" valueField="key" />
                }
                {company && company.id &&
                <Row className="mt-3">
                  <Col md="4">
                    <div className="logo-container" id="upload-logo-container" onClick={()=>{logoRef.current.click()}}>
                      {company.logo ?
                      <img src={'data:image/png;base64,'+company.logo} ></img>
                      :
                      <div className="logo-plus">
                        <span className="logo-plus-icon mb-2">
                          +        
                        </span>
                        <span>Logo here</span>
                      </div>
                      }
                    </div>
                    
                    <input type="file" ref={logoRef} style={{display:'none'}} onChange={(e)=>onChangeLogo(e)}/>
                    <Tooltip placement="bottom" isOpen={tooltipOpen} className="text-left" target="upload-logo-container" toggle={toggletooltip}>
                      You can upload your logo here
                    </Tooltip>
                  </Col>
                  <Col md="8" className="company-name">
                    {company?company.company:''}
                  </Col>
                </Row>
                }
                <Row className="mt-3">
                  <Col md="12">
                    <div className="position-relative">
                      <div 
                        style={{
                          whitespace: 'pre-line',
                          width:'100%',
                          height:'250px',
                          overflowX:'hidden',
                          overflowY:'auto',
                          padding:'10px 12px',
                          border:'1px solid #d0d0d0',
                          borderRadius: 3
                        }}
                      >
                        <Memo memos = {memos} removememo = {removememo}/>
                      </div>         
                      <span style={{position:'absolute', bottom:2, right: 20, display:'flex', background:'white'}}>
                        <i style={{fontSize:18}} className="fa fa-commenting-o mr-2" aria-hidden="true"></i>    
                        <i onClick={()=>setNoteModal(true)} style={{fontSize:19, marginTop:1}} className="fa fa-plus-square-o cursor-pointer" aria-hidden="true"></i>    
                      </span>       
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col xs="4" className="card-col">            
                {role=="admin"?
                <CompanyForm role={role} company={company} updateCompany={updateCompany}  onChangeCompany={values => {props.onChangeCompany(values)}}/>:
                <CompanyForm role={role} company={company} updateCompany={updateCompany} onChangeCompany={()=>{}}/>
                }
              </Col>
              <Col xs="4" className="card-col">                       
                <ContactForm company={company} updateContact={updateContact}/>
              </Col>
            </Row>
          </Col>  
        </Row>
      </Collapse>
      <Modal className="modal-lg conversation-log" isOpen={noteModal} toggle={toggleNote} size="lg">
        <ModalHeader toggle={toggleNote}>
          <h3 className="h4 font-weight-bold mb-0">
          Conversation Log
          </h3>
        </ModalHeader>
        <ModalBody>
              <FormGroup>
                <Memo memos = {memos} removememo = {removememo}/>
              </FormGroup>
              <FormGroup>
              {/* <Input type="input" rows="" value={newMemoNote} onChange={(e)=>setNewMemoNote(e.target.value)} placeholder="Type here..."/> */}
              <Editor
                initialValue={''}
                apiKey='tjdmpms7zl95nzbouj8gcxhkk9q122xd7fsce8wjk0hqwn8g'
                init={{
                  plugins: 'link image code',
                  toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | code',
                  content_style: "p { margin: 0 0 3px 0; }",
                }}
                onChange={(e)=>setNewMemoNote(e.target.getContent())}
              />
              
              </FormGroup>
              <div style={{display:'flex', justifyContent:'flex-end', padding:"0 20px"}}>
                <Button className="" onClick={()=>{document.getElementById(`upload-file`).click();}}  color="primary" type="button">
                  Upload File
                </Button>
                <Button color="primary" onClick={()=>addMemo()}>Add</Button>{' '}
                <Button color="secondary" onClick={toggleNote}>Close</Button>
              </div>
              <input type="file" id={`upload-file`} style={{display:'none'}} onChange={(e)=>uploadfile(e)}/>
        </ModalBody>            
      </Modal>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    quote: state.quote,
  };
};

const mapDispatchProps = (dispatch) => {
  return {    
    setLogo: logoImage=>dispatch(setLogo(logoImage)),
    setSelectedContactUser: (selectedContactUser)=>dispatch(setSelectedContactUser(selectedContactUser)),
    setSelectedContactAddress: selectedContactAddress=>dispatch(setSelectedContactAddress(selectedContactAddress)),
    setSelectedContactInfo: selectedContactInfo=>dispatch(setSelectedContactInfo(selectedContactInfo)),
    setSelectedCompany: selectedCompany=>dispatch(setSelectedCompany(selectedCompany)),
    setValidDate: date=>dispatch(setValidDate(date)),
    setQuoteLabel: value=>dispatch(setQuoteLabel(value)),
    setClientOrderNumber: value=>dispatch(setClientOrderNumber(value)),
    setDeliveryRequired: value=>dispatch(setDeliveryRequired(value)),
    setCompanies: companies=>dispatch(setCompanies(companies)),
    setCompanyUpdated: value=>dispatch(setCompanyUpdated(value)),
    setContactUpdated: value=>dispatch(setContactUpdated(value)),
    setQuoteLoading: value=>dispatch(setQuoteLoading(value))
  };
};


export default connect(mapStateToProps, mapDispatchProps)(Index);